import connect from "../../shared/data-store/connect";
import {
	store,
	ACTION_SET_CONTRACT_FILTER,
} from "../components/hotel-list/DataStore";
import { render, html } from "lit-html";

customElements.define(
	"esc-hotel-list-contract-filter",
	class extends connect(HTMLElement, store) {
		update(state) {
			render(
				html`
					<label>
						<input
							type="checkbox"
							?checked=${state.filters.contract == 1}
							@change=${this.onChange}
						/>
						Nur Vertragshotels
					</label>
				`,
				this,
				{ host: this },
			);
		}

		onChange(event) {
			this.dispatchAction(
				ACTION_SET_CONTRACT_FILTER,
				event.target.checked ? 1 : null,
			);
		}
	},
);
